
import axios from "axios";
import { ResponseAPIWithPagination } from "../../../common/types/API.types";
import { MinigirdPatch, Minigrid, MinigridArchitecture, MinigridFilter, MinigridLiveSnapshot, MinigridLocationEnriched } from "../types/minigridtypes";
import { FileDtoIn } from "../../../common/types/files.types";
import { isValidInstallationCode, normalizeInstallationCode } from "../utils/installationCode";


const BACKEND_URL = process.env.REACT_APP_BACKEND_API_URL+'/api/v1';



export const getAllMinigrids = async (currentPage: number, pageSize: number, filter?: MinigridFilter) => {

    const params =  "currentPage=" + currentPage + "&pageSize=" + pageSize;
    // Une recherche qui a la forme d'un code d'installation filtre exactement
    // sur le code (la recherche plein texte découperait « MG-BJ-0042 »).
    const code = normalizeInstallationCode(filter?.querySearch);
    const byCode = isValidInstallationCode(code);
    const where = [
        filter?.accountId ? "minigrid_account_id=" + filter.accountId : null,
        byCode ? "minigrid_installation_code=" + code : null,
    ].filter(Boolean).join("|");
    const filterParams = "orderByQuery=-minirgrid_updated_at"
        + (filter?.querySearch && !byCode ? "&query=" + encodeURIComponent(filter.querySearch) : "")
        + (where ? "&whereQuery=" + encodeURIComponent(where) : "");
    return (await axios.get<ResponseAPIWithPagination<Minigrid>>(`${BACKEND_URL}/minigrids?${params}&${filterParams}`)).data;
}

export const deleteMinigrid = async (minigridId: string) => {
    return (await axios.delete<null>(`${BACKEND_URL}/minigrids/${minigridId}`)).data;
}

export const getSingleMinigrid = async (minigridId: string) => {

    return (await axios.get<Minigrid>(`${BACKEND_URL}/minigrids/${minigridId}`)).data;
}

export const createMinigrid = async (minigrid: MinigirdPatch) => {
    return (await axios.post<Minigrid>(`${BACKEND_URL}/minigrids`, minigrid)).data;
}

export const updateMinigrid = async (minigridId: string, files: FileDtoIn[] | undefined | null, minigrid: Minigrid) => {
    
    const file = files?.[0] || null;
    if ( file && !file.ignore) {
        const result = await axios.post<Minigrid>(`${BACKEND_URL}/minigrids/${minigridId}/images`, file);
        minigrid.minigrid_tumbnail_url = result.data.minigrid_tumbnail_url;
    }
    if (!file ){
        minigrid.minigrid_tumbnail_url = "";
    }
    

    return (await axios.put<Minigrid>(`${BACKEND_URL}/minigrids/${minigridId}`, minigrid)).data;
}

export const uploadImageToMinigrid = async (file: FileDtoIn, minigridId: string) => {

    return (await axios.post<Minigrid>(`${BACKEND_URL}/minigrids/${minigridId}/images`, file)).data;
}

// Rattache le minigrid à son code d'installation. Route dédiée : le CRUD
// générique n'écrit jamais le code. 409 si le code est porté ailleurs ou si le
// minigrid en porte déjà un autre (jamais d'écrasement depuis l'interface).
export const setInstallationCode = async (minigridId: string, code: string) => {
    return (await axios.put<Minigrid>(`${BACKEND_URL}/minigrids/${minigridId}/installation-code`, {
        minigrid_installation_code: normalizeInstallationCode(code),
    })).data;
}

export const getMinigridLive = async (minigridId: string): Promise<MinigridLiveSnapshot> => {
    return (await axios.get<MinigridLiveSnapshot>(`${BACKEND_URL}/minigrids/${minigridId}/live`)).data;
}

export const getMinigridLocations = async (): Promise<MinigridLocationEnriched[]> => {
    return (await axios.get<MinigridLocationEnriched[]>(`${BACKEND_URL}/minigrids/locations`)).data;
}

export const getMinigridArchitecture = async (minigridId: string): Promise<MinigridArchitecture> => {
    return (await axios.get<MinigridArchitecture>(`${BACKEND_URL}/minigrids/${minigridId}/architecture`)).data;
}



export const minigridAPI = {
    getAllMinigrids,
    deleteMinigrid,
    getSingleMinigrid,
    createMinigrid,
    updateMinigrid,
    uploadImageToMinigrid,
    getMinigridLive,
    getMinigridLocations,
    getMinigridArchitecture,
    setInstallationCode,
}

export default minigridAPI